import { useMemo, useState } from 'react';
import { __t } from './i18n';
import Accordion from './Accordion';
import { Box, Text } from './styles';
import SearchInput from './SearchInput';
import HtmlParser from './HtmlParser';
import { SpacingIndex, responsiveProps } from './theme';

const keys = [
  'howـregister',
  'how_enter_discount_code',
  'faildـpay',
  'buyـsubscription',
  'pay',
  'foreignـcountry',
  'whyـbuyـsubscription',
  'cancelـsubscription',
  'enterـcontactـinfo',
  'resendـsms',
  'discountـcode',
  'platforms',
];
const list = keys.map((id) => ({
  id,
  question: __t('static.faq.qs.' + id),
  answer: __t('static.faq.aw.' + id),
}));

export default function FAQList({ boxMarginBottom = 4, boxMarginTop = 7 }: {
  boxMarginBottom?: responsiveProps<string | SpacingIndex>,
  boxMarginTop?: responsiveProps<string | SpacingIndex>
}) {
  const [value, setValue] = useState<string>('');
  const data = useMemo(() => {
    const filteredData = list.filter((item) => item.question.includes(value) || item.answer.includes(value));
    return filteredData;
  }, [value]);

  const handleChangeSearchInput = (value: string) => {
    setValue(value);
  };

  return (
    <>
      <Box mb={boxMarginBottom} mt={boxMarginTop}>
        <SearchInput
          value={value}
          placeholder={__t('static.faq.searchـplaceholder')}
          onChange={handleChangeSearchInput}
          inputSize="default"
        />
      </Box>
      {data.map(({ id, question, answer }) => (
        <Accordion title={question} key={id}>
          <HtmlParser data={answer} />
        </Accordion>
      ))}
      {data.length === 0 && <Text align="center">{__t('static.faq.question_not_found')}</Text>}
    </>
  );
}
